import { FormControl, FormGroup } from "@angular/forms";
import { ICountry } from "./country.model";
import { Gender } from "../enums/gender.enum";

export type CustomerDataFormGroupModel = FormGroup<{
  id: FormControl<string>,
  firstName: FormControl<string>,
  lastName: FormControl<string>,
  nameInfix: FormControl<string>,
  mobileNumber: FormControl<string>,
  gender: FormControl<Gender | any>,
  email: FormControl<string>,
  country: FormControl<ICountry>
}>
